import styled from 'styled-components'

const PaymentMethodSwitcherItemImageUi = styled.img`
  margin-left: auto;
  flex-shrink: 1;
  min-width: 1px;
`

export default PaymentMethodSwitcherItemImageUi
